import { Row, Card, Col, CardBody, CardTitle } from "reactstrap";
import React, { useState } from "react";
import { Loader } from "../../../custom/components/Loader";
import SweetAlert from "react-bootstrap-sweetalert";
import { requestVesselAccess } from "../../../api/controller/MyVesselController";
import notify from "../../../custom/helpers/Notify";

const RequestVesselAccess = ({ setCurrentScreen }) => {
  const [loading, setLoading] = useState(false);
  const [refCode, setRefCode] = useState("");

  const [successDlg, setSuccessDlg] = useState(false);
  const [successDlgText] = useState("");
  const [errorDlg, setErrorDlg] = useState(false);
  const [errorDlgText, setErrorDlgText] = useState("");
  const [error, setError] = useState({});

  const handleSubmit = async () => {
    setLoading(true);
    setError({});
    const response = await requestVesselAccess({
      Reference: refCode,
    });
    if (response.Status === "error") {
      setErrorDlgText(response.Message);
      setErrorDlg(true);
      setError({ Message: response.Message });
    } else {
      setCurrentScreen("initial");
      notify({ status: "success", message: "Request sent successfully." });
      // setSuccessDlgText("Request sent successfully.");
      // setSuccessDlg(true);
    }
    setLoading(false);
  };

  return (
    <React.Fragment>
      <Loader loading={loading}></Loader>
      <button
        className="btn btn-primary fs-6 py-1"
        onClick={() => setCurrentScreen("initial")}
      >
        <span className="mdi mdi-chevron-left align-middle fs-3 me-2"></span>
        <span className="">Back</span>
      </button>
      <Card className="px-3 py-1 mt-4 mb-3">
        <Col>
          <h4 className="pt-3 font-weight-semibold ">Request Vessel Access</h4>
        </Col>
        <Row>
          <Col className="col-12">
            <label className="col-form-label">
              Enter the Vessel Reference Code
            </label>
          </Col>
          <Col className="col-md-4 col-lg-4 col-xl-3">
            <input
              className="form-control"
              type="text"
              value={refCode}
              onChange={(e) => setRefCode(e.target.value)}
            />
          </Col>
        </Row>
        <Col sm={6}>
          <div>
            <div className="col-md-10"></div>
          </div>
        </Col>
        <Col>
        <Row>
            <Col className="col-md-4 col-lg-4 col-xl-3">
              <div className="mt-2 pt-2 mb-3">
                <button
                  className="btn btn-primary fs-6 w-100"
                  onClick={() => handleSubmit()}
                >
                  <span className="mdi mdi-check align-middle fs-3 me-2"></span>
                  <span className="">Submit Request</span>
                </button>
              </div>
            </Col>
          </Row>
        </Col>
        {error.Message && error.Message.length > 0 ? (
          <Col>
            <Card color="danger" className="text-white-50">
              <CardBody className="p-3">
                <CardTitle className="mb-2 text-white">
                  <i className="mdi mdi-block-helper me-3" />
                  Error
                </CardTitle>
                <span className="text-white">{error.Message}</span>
              </CardBody>
            </Card>
          </Col>
        ) : null}
      </Card>
      {successDlg ? (
        <SweetAlert
          success
          title={"Success!"}
          confirmBtnText={"Close"}
          onConfirm={() => {
            setSuccessDlg(false);
          }}
        >
          <span>{successDlgText}</span>
        </SweetAlert>
      ) : null}
      {errorDlg ? (
        <SweetAlert
          error
          title={"Error!"}
          confirmBtnText={"Close"}
          onConfirm={() => {
            setErrorDlg(false);
          }}
        >
          {errorDlgText}
        </SweetAlert>
      ) : null}
    </React.Fragment>
  );
};
export default RequestVesselAccess;
